var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappCircleWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    transform: "matrix(0.999997 0.00264635 0.0019848 0.999998 0.984131 0.590332)",
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_55248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5653 25.7231C49.5653 12.6382 38.9579 2.03076 25.873 2.03076C12.7881 2.03076 2.18066 12.6382 2.18066 25.7231C2.18066 38.808 12.7881 49.4154 25.873 49.4154C38.9579 49.4154 49.5653 38.808 49.5653 25.7231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7604 37.9584L27.7552 37.9584C25.6347 37.9576 23.5511 37.4003 21.7005 36.3429L14.9839 38.1885L16.7814 31.3107C15.6726 29.2977 15.0892 27.0144 15.0901 24.675C15.0929 17.3568 20.7767 11.4028 27.7603 11.4028C31.1497 11.4044 34.3308 12.7866 36.7231 15.2955C39.1151 17.8043 40.4317 21.139 40.4303 24.6855C40.4277 32.0022 34.7461 37.9554 27.7604 37.9584ZM22.0113 33.94L22.3959 34.1792C24.0127 35.1843 25.8661 35.7162 27.7558 35.7169L27.7601 35.7169C33.5643 35.7169 38.2885 30.7678 38.2909 24.6848C38.2919 21.737 37.1976 18.9653 35.2094 16.88C33.221 14.7947 30.577 13.6457 27.7642 13.6447C21.9555 13.6447 17.2313 18.5933 17.229 24.6759C17.2282 26.7604 17.7849 28.7905 18.8391 30.5469L19.0895 30.9643L18.0256 35.0354L22.0113 33.94ZM33.7103 27.5432C33.931 27.655 34.0801 27.7305 34.1438 27.8418C34.2229 27.9801 34.2229 28.6441 33.9594 29.4189C33.6953 30.1935 32.4306 30.9008 31.8223 30.9958C31.2769 31.0812 30.5867 31.117 29.8283 30.8645C29.3685 30.7116 28.7789 30.5074 28.0236 30.1658C25.0557 28.8233 23.05 25.8099 22.6709 25.2403C22.6444 25.2004 22.6258 25.1725 22.6154 25.158L22.6129 25.1545C22.4453 24.9203 21.3227 23.3512 21.3227 21.7273C21.3227 20.1996 22.0391 19.3989 22.3688 19.0303C22.3914 19.005 22.4121 18.9818 22.4308 18.9605C22.7209 18.6285 23.0639 18.5455 23.275 18.5455C23.486 18.5455 23.6973 18.5475 23.8817 18.5572C23.9045 18.5584 23.9282 18.5583 23.9526 18.5582C24.1371 18.557 24.3671 18.5556 24.594 19.1265C24.6813 19.3463 24.809 19.672 24.9438 20.0155C25.2162 20.7103 25.5171 21.478 25.5701 21.5891C25.6493 21.7551 25.702 21.9487 25.5965 22.1701C25.5807 22.2033 25.566 22.2347 25.552 22.2646C25.4727 22.4341 25.4144 22.5588 25.2799 22.7233C25.227 22.788 25.1724 22.8578 25.1177 22.9275C25.0088 23.0665 24.8999 23.2054 24.8051 23.3044C24.6465 23.4698 24.4816 23.6492 24.6663 23.9813C24.8509 24.3133 25.4863 25.3993 26.4274 26.2787C27.4391 27.224 28.3184 27.6236 28.764 27.8261C28.8511 27.8657 28.9216 27.8977 28.9733 27.9248C29.2898 28.0909 29.4745 28.0631 29.6591 27.8418C29.8438 27.6205 30.4505 26.8734 30.6615 26.5414C30.8726 26.2095 31.0837 26.2648 31.3738 26.3754C31.6641 26.4862 33.2205 27.2884 33.5371 27.4544C33.5989 27.4868 33.6566 27.5161 33.7103 27.5432Z",
    fill: "url(#paint0_linear_1_55248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_55248",
    x1: 27.7071,
    y1: 11.4028,
    x2: 27.7071,
    y2: 38.1885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62FD7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26D044"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_55248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(2.03369 1.65625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappCircleWhite);
export default __webpack_public_path__ + "static/media/WhatsappCircleWhite.592320d5fa0c31d242d181c19c58f8c1.svg";
export { ForwardRef as ReactComponent };